import { LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { useProfessionalAuth } from "../auth/ProfessionalAuthContext";
import styles from "./Header.module.css";

function getInitials(fullName: string) {
  const parts = fullName
    .split(" ")
    .map((part) => part.trim())
    .filter(Boolean)
    .slice(0, 2);

  if (parts.length === 0) {
    return "P";
  }

  return parts.map((part) => part[0]?.toUpperCase() || "").join("");
}

export default function Header() {
  const navigate = useNavigate();
  const { defaultRoute, logout, user } = useProfessionalAuth();

  async function handleLogout() {
    await logout();
    navigate("/login", { replace: true });
  }

  return (
    <header className={styles.header}>
      <div className={styles.topbar}>
        <button type="button" className={styles.identity} onClick={() => navigate(defaultRoute)}>
          <div className={styles.avatar}>{getInitials(user?.fullName || "")}</div>
          <div className={styles.identityCopy}>
            <span className={styles.kicker}>Area profesional</span>
            <strong>{user?.tenantName || "Negocio"}</strong>
          </div>
        </button>

        <button type="button" className={styles.logoutButton} onClick={() => void handleLogout()}>
          <LogOut size={18} />
          Salir
        </button>
      </div>
    </header>
  );
}
